import { Modal } from "ant-design-vue";
const {  ...other } = Modal;
import "./src/modal.less"

const YwModal = {
  ...other,
  name: "YwModal",
};

YwModal.install = function (Vue) {
  Vue.component(YwModal.name, Modal);
};

export default YwModal;

